/* BELLER: suwak ceny w filtrach.

   Wartosci filtra niosa te same pola co dotad (filter.v.price.gte / .lte);
   suwak tylko je ustawia. Format kwoty czytamy ze wzorca podanego przez snippet,
   zeby nie zakladac separatora ani strony, po ktorej stoi symbol.

   Wersja druga, 21.09.2026. Kontrola kodu wykazala cztery powazne usterki
   pierwszej wersji i wszystkie sa tu naprawione:

   1. Pole typu range przyciaga wartosc do siatki kroku. Gdy najwyzsza cena
      w kolekcji nie byla wielokrotnoscia kroku, uchwyt nie dojezdzal do konca
      i najdrozsza bizuteria znikala z wynikow. Teraz pole liczy STOPNIE, nie zlote,
      a ostatni stopien oznacza doslownie najwyzsza cene kolekcji.
   2. Przeciaganie obslugujemy sami na torze, nie kciukiem pola. Dzieki temu
      dziala tapniecie w linie, zawsze rusza ten uchwyt, ktory jest blizej palca,
      i nic nie przycina pola dotyku (tor lezy w kontenerze z overflow: hidden,
      a poprzednia wersja celowo wystawala poza niego).
   3. Zmiana zgloszona w czasie, gdy panel filtrow sie przebudowuje, przepadala.
      Teraz zgloszenie szuka zywego pola w chwili wysylki, czeka na koniec
      trwajacego odswiezenia, a ustawienie klienta przezywa przebudowe panelu.
   4. Waski zakres z adresu nie jest juz po cichu rozszerzany przy starcie.

   Wersja trzecia, 21.09.2026: skala nieliniowa. Przy kolekcji siegajacej 96 500 zl
   caly przedzial do 2000 zl zajmowal na torze okolo 6 px, wiec malego budzetu nie
   dalo sie ustawic palcem. Teraz polozenie na torze liczy sie z pierwiastka udzialu
   kwoty w maksimum, czyli kwota rosnie z kwadratem drogi. Tani koniec dostaje
   wielokrotnie wiecej miejsca, drogi traci, a kwoty nad suwakiem zawsze pokazuja
   prawde. Pola zakresu maja `step="any"`, wiec przegladarka niczego nie przyciaga;
   krokiem steruje wylacznie nasz kod.

   Wersja czwarta, 21.09.2026, na zgloszenie Blazeja z telefonu:
   cena nie odswieza juz wynikow sama. Panel przebudowywal sie w tle chwile po
   puszczeniu uchwytu i wyrywal go spod palca przy nastepnym ruchu. Teraz cene
   zatwierdza przycisk „Pokaz wyniki", tak jak kazdy inny filtr, gdy klient sam
   go nacisnie. Uchwyt wybieramy po odleglosci w pikselach, nie w zlotych, bo przy
   skali nieliniowej to nie to samo, a tor ma `touch-action: none`, zeby przegladarka
   nie odbierala gestu w polowie przeciagania.

   Wersja piata, 21.09.2026, po drugim zgloszeniu z telefonu: chwyt przy krancach
   toru nadal nie dzialal. Przyczyna byla w tym, gdzie sluchamy ruchu. Nasluch
   siedzial na torze i liczyl na `setPointerCapture`. Gdy przechwycenie nie dochodzi
   do skutku, kazdy ruch palca poza paskiem 34 px przestaje byc dostarczany, a palec
   na telefonie zawsze troche zjezdza w pionie. Teraz ruch i puszczenie lapiemy na
   calym dokumencie, wiec przeciaganie trwa niezaleznie od tego, gdzie waruje palec.
   Pasek dotyku ma 44 px, a przegladarki bez zdarzen wskaznika dostaja te sama
   obsluge na zdarzeniach dotyku. */
(function () {
  if (window.__bmsSuwakCeny) return;
  window.__bmsSuwakCeny = 1;

  /* ostatnie ustawienie klienta, zeby przezylo przebudowe panelu filtrow */
  var stan = null;

  /* Wzorzec to 12345,67 w walucie sklepu, np. „12.345,67 zł" albo „$12,345.67".
     Wyciagamy z niego: tekst przed kwota, tekst po kwocie i separator tysiecy. */
  function rozbierzWzor(wzor) {
    var wynik = { przed: '', po: '', grupa: '' };
    if (!wzor) return wynik;
    var i = wzor.search(/[0-9]/);
    if (i < 0) return wynik;
    var j = wzor.length;
    while (j > 0 && !/[0-9]/.test(wzor.charAt(j - 1))) j--;
    wynik.przed = wzor.slice(0, i);
    wynik.po = wzor.slice(j);
    var rdzen = wzor.slice(i, j);
    var cyfry = rdzen.replace(/[^0-9]/g, '').length;
    var seps = rdzen.replace(/[0-9]/g, '').split('');
    if (!seps.length) return wynik;
    /* siedem cyfr znaczy, ze format pokazuje grosze; wtedy ostatni znak jest
       separatorem dziesietnym, a wczesniejszy separatorem tysiecy */
    if (cyfry >= 7) {
      if (seps.length > 1) wynik.grupa = seps[0];
    } else {
      wynik.grupa = seps[0];
    }
    return wynik;
  }

  function formatuj(n, w) {
    var s = String(Math.round(n));
    if (w.grupa) s = s.replace(/\B(?=([0-9]{3})+(?![0-9]))/g, w.grupa);
    return w.przed + s + w.po;
  }

  function ustaw(el) {
    if (el.__bmsSuwak) return;
    var poleOd = el.querySelector('.bms-suwak-pole-od');
    var poleDo = el.querySelector('.bms-suwak-pole-do');
    var uOd = el.querySelector('.bms-suwak-uchwyt-od');
    var uDo = el.querySelector('.bms-suwak-uchwyt-do');
    var kOd = el.querySelector('.bms-suwak-kropka-od');
    var kDo = el.querySelector('.bms-suwak-kropka-do');
    var tor = el.querySelector('.bms-suwak-tor');
    var zakres = el.querySelector('.bms-suwak-zakres');
    var napisOd = el.querySelector('.bms-suwak-kwota-od');
    var napisDo = el.querySelector('.bms-suwak-kwota-do');
    if (!poleOd || !poleDo || !uOd || !uDo || !kOd || !kDo || !tor || !zakres) return;

    var maks = Math.ceil(parseFloat(el.getAttribute('data-maks')));
    if (!(maks > 0)) return;
    var wzor = rozbierzWzor(el.getAttribute('data-wzor') || '');

    /* Najgrubsze ziarno kwoty w tej kolekcji. */
    var krok = maks > 50000 ? 500 : (maks > 10000 ? 100 : 50);

    /* Ziarno zalezy od wysokosci kwoty, nie od kolekcji. Przy skali nieliniowej
       dol toru dostal duzo miejsca, wiec zaokraglanie wszystkiego do 500 zl
       zmarnowaloby te precyzje: pierwsze 26 px dawalo w kolko 500 zl.
       Nigdy nie schodzimy ponizej ziarna kolekcji, zeby kwoty zostaly okragle. */
    function ziarno(v) {
      var b = v < 1000 ? 50 : (v < 5000 ? 100 : (v < 20000 ? 250 : 500));
      return Math.min(b, krok);
    }

    /* Skala nieliniowa: kwota rosnie z kwadratem drogi po torze, a droga jest
       pierwiastkiem udzialu kwoty w maksimum. Skrajne polozenia daja doslownie
       0 i `maks`, wiec najdrozsza bizuteria nigdy nie wypada z wynikow. */
    function kwotaZP(p) {
      if (!(p > 0)) return 0;
      if (p >= 1) return maks;
      var v = maks * p * p;
      var z = ziarno(v);
      v = Math.round(v / z) * z;
      if (v < 0) v = 0;
      if (v > maks) v = maks;
      return v;
    }
    function pZKwoty(v) {
      if (!(v > 0)) return 0;
      if (v >= maks) return 1;
      return Math.sqrt(v / maks);
    }

    var od, doKw;
    /* Jesli klient ustawil cene i nie zdazyl jej zatwierdzic, a panel przebudowal
       sie z innego powodu (na przyklad po zaznaczeniu innego filtra), jego
       ustawienie ma pierwszenstwo nad tym, co przyszlo z serwera. */
    var swiezeKlienta = false;
    if (stan && stan.maks === maks) {
      var zSerweraOd = parseFloat(poleOd.value);
      var zSerweraDo = parseFloat(poleDo.value);
      if (!(zSerweraOd > 0)) zSerweraOd = 0;
      if (!(zSerweraDo > 0) || zSerweraDo > maks) zSerweraDo = maks;
      if (zSerweraOd !== stan.od || zSerweraDo !== stan.doKw) swiezeKlienta = true;
    }
    if (swiezeKlienta) {
      od = stan.od;
      doKw = stan.doKw;
    } else {
      od = parseFloat(poleOd.value);
      if (!(od > 0)) od = 0;
      if (od > maks) od = maks;
      doKw = parseFloat(poleDo.value);
      if (!(doKw > 0) || doKw > maks) doKw = maks;
      /* Waskiego okna z adresu nie rozszerzamy: to, co widzi klient, ma sie
         zgadzac z tym, co policzyl serwer. */
    }

    /* `step="any"` zdejmuje z przegladarki przyciaganie wartosci do siatki; pola
       niosa kwoty wylacznie dla czytnika ekranu, a ruchem steruje nasz kod. */
    uOd.min = 0; uOd.max = maks; uOd.step = 'any'; uOd.value = od;
    uDo.min = 0; uDo.max = maks; uDo.step = 'any'; uDo.value = doKw;

    function rysuj() {
      var p1 = pZKwoty(od), p2 = pZKwoty(doKw);
      if (p2 < p1) p2 = p1;
      kOd.style.left = 'calc(5px + (100% - 10px) * ' + p1 + ')';
      kDo.style.left = 'calc(5px + (100% - 10px) * ' + p2 + ')';
      zakres.style.left = 'calc(5px + (100% - 10px) * ' + p1 + ')';
      zakres.style.width = 'calc((100% - 10px) * ' + (p2 - p1) + ')';
      if (napisOd) napisOd.textContent = formatuj(od, wzor);
      if (napisDo) napisDo.textContent = formatuj(doKw, wzor);
      uOd.setAttribute('aria-valuetext', formatuj(od, wzor));
      uDo.setAttribute('aria-valuetext', formatuj(doKw, wzor));
    }

    function wpiszPola() {
      /* Serwer renderuje kwoty z groszami („6800.00"). Przepisujemy je w postaci
         calkowitej, bo to ta sama kwota, a adres po odswiezeniu wyglada czysto.
         Zakresu przy tym NIE zmieniamy: rozszerzanie waskiego okna z adresu byloby
         zmiana bez wiedzy klienta i rozjezdzaloby formularz z policzonymi wynikami. */
      poleOd.value = od <= 0 ? '' : String(od);
      poleDo.value = doKw >= maks ? '' : String(doKw);
    }

    function zapisz() {
      wpiszPola();
      stan = { od: od, doKw: doKw, maks: maks, kiedy: Date.now() };
    }

    function ustawKwote(ktory, v) {
      if (ktory === 'od') {
        if (v > doKw - ziarno(doKw)) v = Math.max(0, doKw - ziarno(doKw));
        if (v < 0) v = 0;
        od = v;
        uOd.value = od;
      } else {
        if (v < od + ziarno(od)) v = Math.min(maks, od + ziarno(od));
        if (v > maks) v = maks;
        doKw = v;
        uDo.value = doKw;
      }
      rysuj();
      zapisz();
    }

    /* --- przeciaganie po torze ---
       Obslugujemy je sami, zamiast polegac na kciuku pola zakresu. Dzieki temu
       calym celem dotyku jest pasek 34 px na pelnej szerokosci, tapniecie w linie
       przesuwa blizszy uchwyt, a uchwyty nie zaslaniaja sie nawzajem. */
    function pZX(clientX) {
      var r = tor.getBoundingClientRect();
      var szer = r.width - 10;
      var p = szer > 0 ? (clientX - r.left - 5) / szer : 0;
      if (p < 0) p = 0;
      if (p > 1) p = 1;
      return p;
    }
    function kwotaZX(clientX) {
      return kwotaZP(pZX(clientX));
    }

    var ciagnie = null;

    /* Na duzym ekranie wyniki odswiezaja sie same, tak jak przy kwadracikach.
       Na telefonie nie, bo przebudowa panelu wyrywala uchwyt spod palca.
       Granica 900 px to ta sama, przy ktorej panel przestaje byc szuflada. */
    var zegarOdswiezenia = null;
    function odswiezJesliDuzyEkran() {
      if (window.matchMedia('(max-width: 900px)').matches) return;
      if (zegarOdswiezenia) clearTimeout(zegarOdswiezenia);
      zegarOdswiezenia = setTimeout(function () {
        if (document.querySelector('.bms-facets-loading')) {
          zegarOdswiezenia = setTimeout(odswiezJesliDuzyEkran, 300);
          return;
        }
        var pole = document.querySelector('.bms-suwak-pole-od');
        if (pole) pole.dispatchEvent(new Event('change', { bubbles: true }));
      }, 450);
    }

    /* Ktory uchwyt: ten blizszy palcowi NA TORZE. Liczenie odleglosci w zlotych
       dawalo przy skali nieliniowej zly wynik, bo tam rowne kwoty to nierowne odcinki. */
    function ktoryUchwyt(p) {
      var p1 = pZKwoty(od), p2 = pZKwoty(doKw);
      if (p1 === p2) return p < p1 ? 'od' : 'do';
      return Math.abs(p - p1) <= Math.abs(p - p2) ? 'od' : 'do';
    }

    function zacznij(clientX, dotyk) {
      var p = pZX(clientX);
      ciagnie = ktoryUchwyt(p);
      ustawKwote(ciagnie, kwotaZP(p));
      /* na dotyku fokusu nie zabieramy: obwodka zostawalaby zapalona po gescie */
      if (!dotyk) {
        var pole = ciagnie === 'od' ? uOd : uDo;
        try { pole.focus({ preventScroll: true }); } catch (err) { pole.focus(); }
      }
    }

    /* Ruch i puszczenie lapiemy na dokumencie, nie na torze. Przechwycenie wskaznika
       bywa zawodne, a wtedy kazdy ruch poza paskiem przestaje byc dostarczany.
       Palec na telefonie zawsze troche zjezdza w pionie, wiec bez tego przeciaganie
       urywalo sie po kilku pikselach, najdotkliwiej przy krancach toru. */
    function ruchWskaznika(e) {
      if (!ciagnie) return;
      ustawKwote(ciagnie, kwotaZX(e.clientX));
      if (e.cancelable) e.preventDefault();
    }
    function koniecWskaznika() {
      if (!ciagnie) return;
      ciagnie = null;
      document.removeEventListener('pointermove', ruchWskaznika);
      document.removeEventListener('pointerup', koniecWskaznika);
      document.removeEventListener('pointercancel', koniecWskaznika);
      odswiezJesliDuzyEkran();
    }

    function ruchDotyku(e) {
      if (!ciagnie || !e.touches || !e.touches.length) return;
      ustawKwote(ciagnie, kwotaZX(e.touches[0].clientX));
      if (e.cancelable) e.preventDefault();
    }
    function koniecDotyku() {
      if (!ciagnie) return;
      ciagnie = null;
      document.removeEventListener('touchmove', ruchDotyku);
      document.removeEventListener('touchend', koniecDotyku);
      document.removeEventListener('touchcancel', koniecDotyku);
    }

    if (window.PointerEvent) {
      tor.addEventListener('pointerdown', function (e) {
        if (e.button && e.button !== 0) return;
        zacznij(e.clientX, e.pointerType === 'touch');
        document.addEventListener('pointermove', ruchWskaznika, { passive: false });
        document.addEventListener('pointerup', koniecWskaznika);
        document.addEventListener('pointercancel', koniecWskaznika);
        if (e.cancelable) e.preventDefault();
      });
    } else {
      tor.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches.length) return;
        zacznij(e.touches[0].clientX, true);
        document.addEventListener('touchmove', ruchDotyku, { passive: false });
        document.addEventListener('touchend', koniecDotyku);
        document.addEventListener('touchcancel', koniecDotyku);
        if (e.cancelable) e.preventDefault();
      }, { passive: false });
      tor.addEventListener('mousedown', function (e) {
        zacznij(e.clientX, false);
        function ruchMyszy(ev) { if (ciagnie) ustawKwote(ciagnie, kwotaZX(ev.clientX)); }
        function koniecMyszy() {
          ciagnie = null;
          document.removeEventListener('mousemove', ruchMyszy);
          document.removeEventListener('mouseup', koniecMyszy);
        }
        document.addEventListener('mousemove', ruchMyszy);
        document.addEventListener('mouseup', koniecMyszy);
        e.preventDefault();
      });
    }

    /* --- klawiatura ---
       Obslugujemy ja sami, zeby jedno nacisniecie zmienialo kwote o rowny krok.
       Przy skali nieliniowej ruch natywny bylby raz gruby, raz drobny, zaleznie
       od miejsca na torze. */
    function zKlawisza(e, ktory) {
      var k = e.key;
      var kwota = ktory === 'od' ? od : doKw;
      var z = ziarno(kwota);
      var nowa = null;
      if (k === 'ArrowLeft' || k === 'ArrowDown') nowa = kwota - z;
      else if (k === 'ArrowRight' || k === 'ArrowUp') nowa = kwota + z;
      else if (k === 'PageDown') nowa = kwota - z * 10;
      else if (k === 'PageUp') nowa = kwota + z * 10;
      else if (k === 'Home') nowa = 0;
      else if (k === 'End') nowa = maks;
      if (nowa === null) return;
      e.preventDefault();
      if (nowa < 0) nowa = 0;
      if (nowa > maks) nowa = maks;
      ustawKwote(ktory, nowa);
      odswiezJesliDuzyEkran();
    }
    uOd.addEventListener('keydown', function (e) { zKlawisza(e, 'od'); });
    uDo.addEventListener('keydown', function (e) { zKlawisza(e, 'do'); });

    uOd.addEventListener('focus', function () { kOd.classList.add('bms-suwak-fokus'); });
    uOd.addEventListener('blur', function () { kOd.classList.remove('bms-suwak-fokus'); });
    uDo.addEventListener('focus', function () { kDo.classList.add('bms-suwak-fokus'); });
    uDo.addEventListener('blur', function () { kDo.classList.remove('bms-suwak-fokus'); });

    /* pola liczbowe zostaja w formularzu, ale wypadaja z kolejnosci tabulacji */
    poleOd.setAttribute('tabindex', '-1');
    poleDo.setAttribute('tabindex', '-1');
    poleOd.setAttribute('aria-hidden', 'true');
    poleDo.setAttribute('aria-hidden', 'true');

    el.__bmsSuwak = 1;
    rysuj();
    wpiszPola();
    if (swiezeKlienta) {
      /* przywrocilismy ustawienie klienta; zatwierdzi je przycisk „Pokaz wyniki" */
      zapisz();
    }
    el.classList.add('bms-suwak-gotowy');
  }

  /* Snippet wstawia arkusz wewnatrz formularza, a panel filtrow przy kazdym
     odswiezeniu podmienia `form.innerHTML`, wiec arkusz na moment wypadalby
     z dokumentu. Przenosimy go raz do naglowka i problem znika. */
  function arkuszDoNaglowka() {
    var l = document.querySelector('link[href*="bms-suwak-ceny.css"]');
    if (l && l.parentNode !== document.head) document.head.appendChild(l);
  }

  function uruchom() {
    arkuszDoNaglowka();
    var lista = document.querySelectorAll('.bms-suwak');
    for (var i = 0; i < lista.length; i++) ustaw(lista[i]);
  }

  /* Odroczenie na zegarze, nie na klatce obrazu. `requestAnimationFrame` nie odpala
     w karcie schowanej w tle, wiec blokada zostawala zapalona na zawsze i suwak
     po odswiezeniu wynikow juz sie nie budzil. Zmierzone 21.09.2026. */
  var czeka = null;
  function uruchomPozniej() {
    if (czeka) return;
    czeka = setTimeout(function () { czeka = null; uruchom(); }, 0);
  }

  uruchom();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', uruchom);
  window.addEventListener('load', uruchom);
  /* panel filtrow przerysowuje sie po kazdym odswiezeniu wynikow */
  try {
    var obs = new MutationObserver(uruchomPozniej);
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
